// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609240434/js/" + chunkId + "." + {"44":"31e350f9","225":"7164df4f","481":"080d5c91","486":"1b63f8bf","770":"bcc5c669"}[chunkId] + ".0.9916614999112179.chunk.js";
};